module.exports = __webpack_public_path__ + "img/3.03bea6d8.jpg";